export { default } from './TherigyDashboardList';
